import { ReactNode } from 'react';

interface SkeletonProps {
  className?: string;
  children?: ReactNode;
  /** Optional aria-label so screen readers announce "Loading <area>". */
  label?: string;
}

/**
 * Base skeleton primitive. Use Tailwind sizing classes (`h-6 w-3/4` etc.)
 * via `className` to shape the placeholder.
 *
 * Animation: relies on the built-in Tailwind `animate-pulse`. The colour is
 * `bg-linen` so it inherits whatever the active theme defines for linen
 * (works on light + dark themes — see src/themes/*).
 */
export function Skeleton({ className = '', label }: SkeletonProps) {
  return (
    <div
      role="status"
      aria-label={label}
      aria-busy="true"
      className={`animate-pulse bg-linen rounded-sm ${className}`}
    />
  );
}
